// 認証が必要な場合のページごとのミドルウェア
export default defineNuxtRouteMiddleware(async (to, from) => {
  console.log('middleware:pageAuth', to.fullPath, from.fullPath)

  if (import.meta.client) {
    const storeUser = useStoreUser()
    if (!storeUser.state.isLogin) {
      storeUser.setLoginRedirectPath(to.fullPath)
      return navigateTo('/login')
    }
  }
})
